import {
    Component,
    OnInit
} from '@angular/core';
import { LoginRequestProto } from '../authentication.constants';
import { WebService } from '../../../http/web-service.service';
import { Url } from '../../../http/url-constants';
import { UserService } from '../../../shared/services/user.service';
import { Router } from '@angular/router';
import { AddToCartProto } from '../../../shared/components/components.constants';
import { ProductService } from '../../../shared/services/product.service';
import { AppUtilService } from '../../../app-util.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public loginRequest = new LoginRequestProto();
    public addToCartRequest = new AddToCartProto();
    public addToWishlistRequest = new AddToCartProto();
    public errorMessage: string;

    constructor(private webService: WebService, private userService: UserService, private router: Router,
                public productService: ProductService, public appUtilService: AppUtilService) {
    }

    ngOnInit(): void {
      this.appUtilService.setBrowserTitle('Login');
    }

    login() {
        this.errorMessage = '';
        this.webService.post(Url.API.authentication.login, this.loginRequest).subscribe((response) => {
            if (response.status.code === 200) {
                this.userService.setUserData(response.response);
                if (localStorage.cartItems) {
                    this.addToCartRequest.userId = response.response.userId;
                    const cartItems = JSON.parse(localStorage.cartItems);
                    cartItems.forEach((v) => {
                        this.addToCartRequest.productIds.push(v.id);
                    });
                    this.addToCart();
                }
                if (localStorage.wishlistItems) {
                    this.addToWishlistRequest.userId = response.response.userId;
                    const wishlistItems = JSON.parse(localStorage.wishlistItems);
                    wishlistItems.forEach((v) => {
                        this.addToWishlistRequest.productIds.push(v.id);
                    });
                    this.addToWishlist();
                }
                localStorage.redirectUrl ? this.router.navigateByUrl(localStorage.redirectUrl) : this.router.navigateByUrl('/home');
                localStorage.removeItem(localStorage.redirectUrl);
            } else {
                this.errorMessage = response.status.message;
            }
        });
    }

    addToCart() {
        this.webService.post(Url.API.cart.add, this.addToCartRequest).subscribe((response) => {
            if (response) {
                this.productService.removeAllCartItems();
                this.productService.cartItemsAdded.next(true);
            }
        });
    }

    addToWishlist() {
        this.webService.post(Url.API.wishlist.add, this.addToWishlistRequest).subscribe((response) => {
            if (response) {
                this.productService.removeAllWishlistItems();
            }
        });
    }

}
